import { RouteGroup } from '@/modules/core/app/constants/api.constants';
import { BaseDataResource } from '@/modules/core/app/resources/BaseDataResource';
import { GenericModel } from '@/modules/core/app/models/GenericModel';
import { DISTINCT_VALUES } from '@/modules/ta/widget/widget.constants';

export class UserLoginDataResource extends BaseDataResource {
  constructor() {
    super(RouteGroup.USERLOGINS);
  }

  /**
   *
   * @param serviceId
   * @param dataViewId
   * @param fields
   * @param params
   * @returns {Promise<*>}
   */
  async getValuesDistinct(serviceId, dataViewId, fields, params = {}) {
    params = { ...params, fields };
    return super.getDataValues(GenericModel, DISTINCT_VALUES, params);
  }
}

export default new UserLoginDataResource();
